/* eslint-disable import/no-cycle */
import { useMainStore } from '@/store/mainStore';

export default class ToFlutterService {
  public static connect(): void {
    const mainStore = useMainStore();

    // Make sure flutter channels are available
    const { flutterAppConnect } = window as any;
    if (flutterAppConnect) {
      mainStore.isFlutter = true;
      ToFlutterService.requestFirebaseToken();
    }
  }

  public static topColorHex(color: string): void {
    const { flutterAppTopColorHex } = window as any;
    const payload = { color };

    if (flutterAppTopColorHex) {
      flutterAppTopColorHex.postMessage(JSON.stringify(payload));
    }
  }

  public static downloadMedia(url: string, fileName = ''): void {
    const { flutterAppDownload } = window as any;
    const payload = { url, fileName };

    if (flutterAppDownload) {
      flutterAppDownload.postMessage(JSON.stringify(payload));
    }
  }

  public static openFilePicker(): void {
    const { flutterAppOpenFilePicker } = window as any;

    if (flutterAppOpenFilePicker) {
      flutterAppOpenFilePicker.postMessage('');
    }
  }

  public static openImagePicker(): void {
    const { flutterAppOpenImagePicker } = window as any;

    if (flutterAppOpenImagePicker) {
      flutterAppOpenImagePicker.postMessage('');
    }
  }

  public static openCamera(): void {
    const { flutterAppOpenCamera } = window as any;

    if (flutterAppOpenCamera) {
      flutterAppOpenCamera.postMessage('');
    }
  }

  public static openSystemPermissions(): void {
    const { flutterAppOpenSystemPermissions } = window as any;

    if (flutterAppOpenSystemPermissions) {
      flutterAppOpenSystemPermissions.postMessage('');
    }
  }

  public static requestFirebaseToken(): void {
    const { flutterAppRequestFirebaseToken } = window as any;

    if (flutterAppRequestFirebaseToken) {
      flutterAppRequestFirebaseToken.postMessage('');
    }
  }
}
